import apiPdca from '../../../../helpers/apiPdca'
import { loaded, loading } from '../../../../layout/redux/layoutActions'

export const PDCA_SET_BASE_CONTEXTO = 'PDCA_SET_BASE_CONTEXTO'
export const PDCA_SET_BASE_CONTEXTO_LOADING = 'PDCA_SET_BASE_CONTEXTO_LOADING'
export const PDCA_SET_BASE_CONTEXTO_ERRO = 'PDCA_SET_BASE_CONTEXTO_ERRO'
export const PDCA_RESET_BASE_CONTEXTO = 'PDCA_RESET_BASE_CONTEXTO'
export const PDCA_SET_BASE_ERRO = 'PDCA_SET_BASE_ERRO'
export const PDCA_SET_BASE_LOAD = 'PDCA_SET_BASE_LOAD'
export const PDCA_SET_PERIODO = 'PDCA_SET_PERIODO'

export const setPdcaBaseContexto = payload => ({
  type: PDCA_SET_BASE_CONTEXTO,
  payload
})

export const setPdcaBaseContextoLoading = payload => ({
  type: PDCA_SET_BASE_CONTEXTO_LOADING,
  payload
})

export const setPdcaBaseContextoErro = payload => ({
  type: PDCA_SET_BASE_CONTEXTO_ERRO,
  payload
})

export const resetPdcaBaseContexto = () => ({
  type: PDCA_RESET_BASE_CONTEXTO
})

export const setPdcaBaseErro = payload => ({
  type: PDCA_SET_BASE_ERRO,
  payload
})

export const setPdcaBaseLoad = payload => ({
  type: PDCA_SET_BASE_LOAD,
  payload
})

export const setPeriodoPdca = ({ dataInicial, dataFinal }) => ({
  type: PDCA_SET_PERIODO,
  payload: {
    dataInicial,
    dataFinal
  }
})

const normalizarRespostaVerificarEmpresaPdca = (responseData, projetoId) => {
  const empresaId = Number(responseData?.empresaid || 0)

  return {
    projetoId: Number(responseData?.projetoid || projetoId),
    empresaPdcaExiste: empresaId > 0,
    empresaPdcaId: empresaId,
    empresaPdcaNome: responseData?.empresadescricao || '',
    projetoNome: responseData?.projetodescricao || ''
  }
}

export const verificarExisteEmpresaPdca = projetoId => {
  return async dispatch => {
    try {
      dispatch(loading())
      dispatch(setPdcaBaseContextoLoading(true))
      dispatch(setPdcaBaseContextoErro(null))

      const response = await apiPdca.get(`/Pdca/VerificarExisteEmpresaPdca?projetoId=${projetoId}`)
      const contexto = normalizarRespostaVerificarEmpresaPdca(response.data, projetoId)

      dispatch(setPdcaBaseContexto(contexto))

      return {
        ok: true,
        contexto
      }
    } catch (error) {
      console.error('Erro ao verificar empresa PDCA:', error)

      dispatch(resetPdcaBaseContexto())
      dispatch(setPdcaBaseContextoErro(error?.response?.data || error))

      return {
        ok: false,
        erro: error?.response?.data || error
      }
    } finally {
      dispatch(setPdcaBaseContextoLoading(false))
      dispatch(loaded())
    }
  }
}

export const limparContextoPdca = () => {
  return dispatch => {
    dispatch(resetPdcaBaseContexto())
  }
}